import React, { useEffect } from 'react';

function OauthCallback(props) {
  const { provider } = props;

  useEffect(() => {
    if (window.opener) {
      // send them to the opening window
      window.opener.postMessage(true);
      // close the popup
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      window.location.replace(`/integrations/${provider}`);
    }
  });

  return <div>Redirecting...</div>;
}

export default OauthCallback;
